module.exports = __webpack_public_path__ + "img/edit.1459a2ca.svg";